<template>
	<div class="container page">
		<van-nav-bar :title="$t('other.finance_password')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
			<template #right>
				<span class="nav-right" @click="save()">{{$t("setting.save")}}</span>
			</template>
		</van-nav-bar>
		<van-cell-group>
			<van-field v-model="o_new_password" :label="$t('other.finance_password')" :placeholder="$t('other.input_finance_password')" />
			<van-field v-model="t_new_password" :label="$t('other.confirm_finance_password')" :placeholder="$t('other.confirm_finance_password')" />
		</van-cell-group>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				o_new_password: "",
				t_new_password: "",
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			save() {
				if (this.t_new_password != this.o_new_password) {
					this.$toast('Hai lần mật khẩu không đáng một')
					return
				}
				this.$http({
					method: 'post',
					data: {
						new_paypwd: this.t_new_password,
					},
					url: 'resetpwd'
				}).then(res => {
					if (res.code == 1) {
						this.$toast(res.msg);
						setTimeout(() => {
							this.$router.push("Mine")
						}, 500);
					} else {
						this.$toast(res.msg);
					}
				})
			},
		},
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.van-cell {
		font-size: 35px;
		line-height: 80px;
	}
</style>